import React from "react";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Card, DescriptionCardHeading, FormLayout, FormLayoutSectionFormatProps} from "peggirkit";
import {slimCardFormLayoutProps} from "@widgets/layout/formLayout/FormLayout";
import FormLayoutSection from "peggirkit/dist/components/Form/Layout/LayoutSection/FormLayoutSection";
import {FormattedMessage, useIntl} from "react-intl";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {FulfillmentType} from "@/data/entities/restaurant";
import FulfillmentStatusUpdater from "@widgets/busyness/editor/fulfillmentStatusUpdater";
import SlimContainer from "@widgets/layout/SlimContainer";

type Props = {
    fulfillmentType: FulfillmentType,
};

const EditFulfillmentCard = ({fulfillmentType}: Props) => {
    const intl = useIntl();
    const {dashboardLocation} = useRestaurant();
    const isDelivery = fulfillmentType === "DELIVERY";

    return (
        <SlimContainer center={false}>
            <Card
                containerClassname={"mt-6 md:mt-10"}
                header={
                    <CardHeader>
                        <DescriptionCardHeading
                            title={intl.formatMessage({id: isDelivery ? "delivering" : "takeaway"})}
                            description={
                                intl.formatMessage(
                                    {
                                        id: isDelivery
                                            ? "deliveryBusynessManagementByLocation"
                                            : "takeawayBusynessManagementByLocation"
                                    },
                                    {location: dashboardLocation.name},
                                )
                            }
                        />
                    </CardHeader>
                }
            >
                <FormLayout {...slimCardFormLayoutProps}>
                    {(layoutProps: FormLayoutSectionFormatProps) => (
                        <FormLayoutSection
                            {...layoutProps}
                            title={<FormattedMessage id={"orderSiteStatus"}/>}
                            description={<FormattedMessage id={"orderSiteStatusDescription"}/>}
                            noBorder
                            noPadding
                        >
                            <FulfillmentStatusUpdater isDelivery={isDelivery}/>
                        </FormLayoutSection>
                    )}
                </FormLayout>
            </Card>
        </SlimContainer>
    );
};

export default EditFulfillmentCard;